import { render, staticRenderFns } from "./addtional-info.vue?vue&type=template&id=41d43d5c&scoped=true&"
import script from "./addtional-info.vue?vue&type=script&lang=js&"
export * from "./addtional-info.vue?vue&type=script&lang=js&"
import style0 from "./addtional-info.vue?vue&type=style&index=0&id=41d43d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d43d5c",
  null
  
)

export default component.exports